module.exports = __webpack_public_path__ + "static/media/LICENSE.6b96bfdd.txt";